export default __webpack_public_path__ + "static/topbanner-bg-2-4368f6cc00746b08198cd03f1733d47e.webp";